/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_DescriptionInputs */

const en_admin_resource_form_description = /** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_admin_resource_form_description = /** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const es_admin_resource_form_description = /** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

const fr_admin_resource_form_description = /** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */
const it_admin_resource_form_description = en_admin_resource_form_description;

/** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_resource_form_description = en_admin_resource_form_description;

/** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */
const pl_admin_resource_form_description = en_admin_resource_form_description;

/** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */
const hu_admin_resource_form_description = en_admin_resource_form_description;

/** @type {(inputs: Admin_Resource_Form_DescriptionInputs) => LocalizedString} */
const ro_admin_resource_form_description = en_admin_resource_form_description;

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Admin_Resource_Form_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_description = /** @type {((inputs?: Admin_Resource_Form_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_description(inputs)
	if (locale === "de") return de_admin_resource_form_description(inputs)
	if (locale === "es") return es_admin_resource_form_description(inputs)
	if (locale === "fr") return fr_admin_resource_form_description(inputs)
	if (locale === "it") return it_admin_resource_form_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_description(inputs)
	if (locale === "pl") return pl_admin_resource_form_description(inputs)
	if (locale === "hu") return hu_admin_resource_form_description(inputs)
	return ro_admin_resource_form_description(inputs)
});
export { admin_resource_form_description as "admin.resource_form.description" }